/* app/js/src/components/recording/recording-assets-manager/recording-assets-manager.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  width: 368px;
  height: 100vh;
  background-color: #eef2f6;
  padding: 16px 0 5px 18px;
}
.search-wrapper {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 321px;
  align-items: center;
  background-color: #ffffff;
  padding: 5px 9px;
  border-radius: 4px;
}
.search-wrapper input[type=search] {
  -webkit-flex: 15 0 0;
  -ms-flex: 15 0 0;
  flex: 15 0 0;
  height: 17px;
  border: none;
  background: none;
  font-size: 0.8em;
  color: #232f3a;
}
.search-wrapper input[type=search]:focus {
  outline: none;
}
.search-wrapper input[type=search]::selection {
  background-color: #232f3a;
  color: #ffffff;
}
.search-wrapper input[type=search]::-moz-selection {
  background-color: #232f3a;
  color: #ffffff;
}
.search-wrapper div {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
.search-wrapper div ::ng-deep svg {
  fill: #879baf;
  -ms-transform: scale(1);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.search-wrapper div:active svg {
  -ms-transform: scale(0.7);
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
  fill: #232f3a;
}
.search-wrapper ::-webkit-input-placeholder {
  color: #c9cdd6;
  font-size: 1em;
  line-height: 1.2em;
}
.search-wrapper :-moz-placeholder {
  color: #c9cdd6;
  font-size: 1em;
  line-height: 1.2em;
}
.search-wrapper ::-moz-placeholder {
  color: #c9cdd6;
  font-size: 1em;
  line-height: 1.2em;
}
.search-wrapper :-ms-input-placeholder {
  color: #c9cdd6;
  font-size: 1em;
  line-height: 1.2em;
}
/*# sourceMappingURL=recording-assets-manager.component.css.map */
